<!-- =========================================================================================
  File Name: AddNewDataSidebar.vue
  Description: Add New Data - Sidebar component
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <vs-sidebar click-not-close position-right parent="body" default-index="1" color="primary" class="add-new-data-sidebar items-no-padding" spacer v-model="isSidebarActiveLocal">
    <div class="mt-6 flex items-center justify-between px-6">
        <h4 v-if="dataId==null">Ajouter Dépense</h4>
        <h4 v-if="dataId!=null">Modifier Dépense</h4>
        <feather-icon icon="XIcon" @click.stop="isSidebarActiveLocal = false" class="cursor-pointer"></feather-icon>
    </div>
  
    <vs-divider class="mb-0"></vs-divider>

    <VuePerfectScrollbar class="scroll-area--data-list-add-new" :settings="settings" :key="$vs.rtl">
      
      <div  class="p-6">
        <ul class="centerx">
        <li>
          <vs-radio v-model="typeDepense" vs-value='1'>Salaire</vs-radio>
        </li>
        <li>
          <vs-radio v-model="typeDepense" vs-value='0'>Dépense</vs-radio>
        </li>
        
      </ul>
      <!-- Product Image -->
      <div v-if="typeDepense=='0'" >
        <template v-if="dataAvatar">
          
          <!-- Image Container -->
          <div class="img-container w-64 mx-auto flex items-center justify-center">
            <img :src="dataAvatar" alt="img" class="responsive">
          </div>

          <!-- Image upload Buttons -->
          <div class="modify-img flex justify-between mt-5">
            <input type="file" class="hidden" ref="updateImgInput" @change="updateCurrImg" accept="image/*">
            <vs-button class="mr-4" type="flat" @click="$refs.updateImgInput.click()">Mettre à jour papier depense</vs-button>
            <vs-button type="flat" color="#999" @click="dataAvatar = null">Supprimer papier depense</vs-button>
          </div>
        </template>
        
        
        <vs-input label="Titre" v-model="dataTitre" class="mt-5 w-full" titre="item-titre" v-validate="'required'" />
        <span class="text-danger text-sm" v-show="errors.has('item-titre')">{{ errors.first('item-titre') }}</span>

        <vs-input label="Value" v-model="datavalue" class="mt-5 w-full" titre="item-value" v-validate="'required'" />
        <span class="text-danger text-sm" v-show="errors.has('item-value')">{{ errors.first('item-value') }}</span>
         
        <vs-textarea label="Description"   class="mt-5 w-full"  v-model="dataDescription" />
        
        <div class="upload-img mt-5" v-if="!dataAvatar">
          <input type="file" class="hidden" ref="uploadImgInput" @change="updateCurrImg" accept="image/*">
          <vs-button @click="$refs.uploadImgInput.click()">Télécharger papier depense</vs-button>
        </div>
      </div>
      <div v-if="typeDepense=='1'" >
        <div class="px-6 py-4">
          <span class="text-lg ml-3 mb-5">Formateur</span>
          <v-select :options="formateur_choices" :clearable="false" :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="formateur_data" class="mb-4 md:mb-0 mt-2" />
        </div>
        <div class="px-6 py-4" v-if="formateur_salaire">
          <span class="text-lg ml-3 mb-5">Salaire</span>
          {{formateur_salaire}} DT
        </div>
        <div class="px-6 py-4" v-if="formateur_salaire">
          <span class="text-lg ml-3 mb-5">Mois</span>
          <datepicker v-model="date_data" :minimumView="'month'" :maximumView="'year'"></datepicker>
        </div>
        
             
        
      </div>
      </div>
    </VuePerfectScrollbar>

    <div class="flex flex-wrap items-center p-6" slot="footer">
      <vs-button v-if="dataId==null" class="mr-6" @click="submitData" :disabled="!isFormValid">Ajouter</vs-button>
      <vs-button v-if="dataId!=null" class="mr-6" @click="submitData" :disabled="!isFormValid">Modifier</vs-button>
      <vs-button type="border" color="danger" @click="isSidebarActiveLocal = false">Annuler</vs-button>
    </div>
  </vs-sidebar>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
//import axios from "../../../http/axios/index.js"
import vSelect from 'vue-select'
import moduledepense from '@/store/depense/moduledomaine.js'
import moduleformateur from '@/store/formateur/moduleformateur.js'
import Datepicker from 'vuejs-datepicker';
export default {
  
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true
    },
    data: {
      type: Object,
      default: () => {},
    }
  },
  
  watch: {
    isSidebarActive(val) {
     
      if(!val) return
      if(Object.entries(this.data).length === 0) {
        this.initValues()
        this.$validator.reset()
      }else {
        console.log('this.data',this.data)
        let {  value,name, id,description,facture,salaire,formateur } = JSON.parse(JSON.stringify(this.data))
        this.dataId = id
        this.dataAvatar = facture
        this.dataTitre = name
        this.datavalue = value
        this.date_data = value
        this.dataDescription = description
        this.typeDepense = salaire
        this.formateur_id = formateur
        // console.log(this.dataId,this.dataTitre,this.dataValue,this.dataDescription)
        this.initValues()
       
      }
      // Object.entries(this.data).length === 0 ? this.initValues() : { this.dataId, this.dataName, this.dataCategory, this.dataOrder_status, this.dataPrice } = JSON.parse(JSON.stringify(this.data))
    }
  },
  data() {
    return {
      datavalue:null,
      date_data:null,
      dataDescription:null,
      formateur_salaire:null,
      formateur_nom_prenom:null,
      formateur_id:null,
      typeDepense:null,
      change_image: false,
      dataAvatar: false,
      newformation: false,
      dataTitre: null,  
      dataId: null,
      settings: { // perfectscrollbar settings
          maxScrollbarLength: 60,
          wheelSpeed: .60,
      },
    }
  },
  computed: {
    formateur_choices() {
        let opts=[];
          console.log(this.$store.state.formateur.formateur_s)
          for (var formateur of this.$store.state.formateur.formateur_s){
              opts.push({label:formateur.nom_prenom, value: formateur.id});
            }
         return opts
    },
    formateur_data: {
      get() {
        
        
        
        },
      set(obj) {
        
        for (var formateur of this.$store.state.formateur.formateur_s){
          
              if(formateur.id==obj.value){
              this.formateur_salaire=formateur.salaire
              this.formateur_id=formateur.id
              this.formateur_nom_prenom=formateur.nom_prenom
              
              }
        }
      }
    },
    domaineData() {
      return this.$store.state.domaine.users
    },
    isSidebarActiveLocal: {
      get() {
        console.log(this.isSidebarActive)
        return this.isSidebarActive
      },
      set(val) {
        if(!val) {
          this.$emit('closeSidebar')
          // this.$validator.reset()
          // this.initValues()
        }
      }
    },
    
    isFormValid() {
      return !this.errors.any() 
    }
  },
  
  methods: {
    updateCurrImg(input) {
      if (input.target.files && input.target.files[0]) {
        var reader = new FileReader()
        reader.onload = e => {
          this.dataAvatar = e.target.result
        }
        reader.readAsDataURL(input.target.files[0])
         this.file = input.target.files[0]
       this.change_image = true
       console.log("this.change_image",this.change_image)
      }
    },
    initValues() {
      if(this.data.id) return
        this.dataId = null
        this.dataTitre = ""
        this.datavalue = null
        this.date_data = null
        this.dataDescription = null
        this.dataAvatar = null
        this.formateur_salaire= null
        this.formateur_nom_prenom= null
        this.typeDepense= null
        this.formateur_id=null
    },
    submitData() {
      this.$validator.validateAll().then(result => {
          this.newformation= true
          console.log('this.newformation',this.newformation)
          if (result) {
            if(this.typeDepense=='0'){
              console.log(this.dataTitre,this.datavalue,this.dataDescription,this.dataId)
              const obj = {
              id: this.dataId,
              salaire: 0,
              name: this.dataTitre,
              value: this.datavalue,
             
              description: this.dataDescription,
              facture: this.dataAvatar
            }
            // console.log('1',!obj.id)
                  
              
              if(!obj.id){
              this.$store.dispatch("depense/addItem", obj).then(()   => {  this.$store.dispatch("depense/fetchUsers").catch(err => { console.error(err) });  this.showMessage('success', 'ajouter', 'ajouté avec succès') }).catch(err => { console.error(err); this.activeLoading = false; this.$vs.loading.close(); this.showMessage('danger', 'pas ajouté', 'une erreur: '+ err) })
              // this.$store.dispatch("depense/fetchUsers").catch(err => { console.error(err) })
              }else{
                // alert(obj.facture)
                if(this.change_image){
                    this.$store.dispatch("depense/updateavatar", obj)
                }
               this.$store.dispatch("depense/updateRecord", obj)
               this.$store.dispatch("depense/fetchUsers").catch(err => { console.error(err) })
              }

            this.$emit('closeSidebar')
            this.initValues()
            }else{
              const obj = {
              id: this.dataId,
              name: this.formateur_nom_prenom,
              value: this.formateur_salaire,
              description: 'salaire formateur',
              facture: this.dataAvatar,
              salaire: 1,
              date: this.date_data,
              formateur: this.formateur_id
              }
              console.log(this.dataTitre)
              console.log('2',obj)
              if(!obj.id){
              this.$store.dispatch("depense/addItem", obj).then(()   => {  this.$store.dispatch("depense/fetchUsers").catch(err => { console.error(err) });  this.showMessage('success', 'ajouter', 'ajouté avec succès') }).catch(err => { console.error(err); this.activeLoading = false; this.$vs.loading.close(); this.showMessage('danger', 'pas ajouté', 'une erreur: '+ err) })
              // this.$store.dispatch("depense/fetchUsers").catch(err => { console.error(err) })
              }else{
                  
                  if(this.change_image){
                    this.$store.dispatch("depense/updateavatar", obj)
                  }
                 this.$store.dispatch("depense/updateRecord", obj)
                 this.$store.dispatch("depense/fetchUsers").catch(err => { console.error(err) })
                
               
              }

            this.$emit('closeSidebar')
            this.initValues()
            }
            
            // console.log(this.data)
            //const image = this.file
            //axios.post('http://127.0.0.1:8000/api/addformation',obj,image)
          }
      })
    
    },
    showMessage(color, title, text) {
              this.$vs.notify({
                color: color,
                title: 'depense '+title,
                text: 'La nouveau depense '+text
              })
            },
    
  },
  components: {
    VuePerfectScrollbar,
    vSelect,
    Datepicker
  },
  created() {
  if(!moduledepense.isRegistered) {
      this.$store.registerModule('depense', moduledepense)
      moduledepense.isRegistered = true
    }

  if(!moduleformateur.isRegistered) {
      this.$store.registerModule('formateur', moduleformateur)
      moduleformateur.isRegistered = true
    }
  //  this.$store.dispatch("depense/fetchUsers").catch(err => { console.error(err) })
   this.$store.dispatch("formateur/fetchformateursalarie").catch(err => { console.error(err) })

  }

    
  
}
</script>

<style lang="scss" scoped>
.add-new-data-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 52010;
  }

  ::v-deep .vs-sidebar {
    z-index: 52010;
    width: 400px;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new {
    // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
    height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);
}
</style>
